// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {241: "9bb93230582ecd9f",616: "c0847615bcef48de",705: "b8fef02ae109cb11",80: "5a15c48db4d63486",822: "a60037849acc9384",91: "d31578f82978d3cd",}[chunkId] + ".js"
}